import { render, staticRenderFns } from "./error-overlay.vue?vue&type=template&id=0f7f7745&scoped=true&"
import script from "./error-overlay.vue?vue&type=script&lang=ts&"
export * from "./error-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./error-overlay.vue?vue&type=style&index=0&id=0f7f7745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f7745",
  null
  
)

export default component.exports